import { forwardRef } from 'react';

import type { LinkExternalProps } from '../@types';
import { LINK_CONST } from '../@types';

import { Link } from './Link.styles';

const LinkExternal = forwardRef(
  ({ children, pathname, ...props }: LinkExternalProps, ref: LinkExternalProps['ref']) => (
    <Link.Base
      ref={ref}
      data-testid={LINK_CONST.TEST_ID}
      href={pathname}
      rel="noopener"
      target="_blank"
      {...props}
    >
      {children}
    </Link.Base>
  ),
);
LinkExternal.displayName = 'LinkExternal';
export default LinkExternal;
